export default "__VITE_ASSET__34c0112a__"